import scrollIntoView from 'scroll-into-view-if-needed';

export default function scrollToRef(ref, additionalOptions = {}) {
  const options = {
    scrollMode: 'if-needed',
    behavior: 'smooth',
    block: 'center',
    ...additionalOptions,
  };

  scrollIntoView(ref.current, options);
}
